var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignOptimization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #1356da; /* Cambi\xE9 el color aqu\xED */\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "17.67 32.98 17.67 5.05 60.67 5.05 60.67 47.32 32.01 47.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.94,41.78l-2.51-2.51,4.2-4.2,2.49,2.51c.8-.47,1.66-.83,2.57-1.06v-3.55h5.95v3.55c.91.23,1.78.6,2.57,1.06l2.49-2.51,4.2,4.2-2.51,2.51c.47.8.81,1.66,1.05,2.56h3.56v5.95h-3.56c-.23.91-.6,1.78-1.05,2.57l2.51,2.49-4.2,4.2-2.49-2.51c-.8.47-1.66.83-2.57,1.06v3.55h-5.95v-3.55c-.91-.23-1.78-.6-2.57-1.06l-2.49,2.51-4.2-4.2,2.51-2.49c-.47-.8-.83-1.66-1.06-2.57h-3.55v-5.95h3.55c.23-.9.6-1.76,1.06-2.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.67,
    cy: 47.31,
    r: 7.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "17.67 43.13 17.67 47.31 20.5 48.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.67,
    y1: 14.5,
    x2: 60.67,
    y2: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24.57,
    cy: 22.39,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 34.3,
    cy: 22.39,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.04,
    cy: 22.39,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 53.78,
    cy: 22.39,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 34.3,
    cy: 33.38,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.04,
    cy: 33.38,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 53.78,
    cy: 33.38,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.94,
    y1: 2.34,
    x2: 24.94,
    y2: 7.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.43,
    y1: 2.34,
    x2: 34.43,
    y2: 7.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43.92,
    y1: 2.34,
    x2: 43.92,
    y2: 7.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 53.4,
    y1: 2.34,
    x2: 53.4,
    y2: 7.76
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignOptimization);
export default __webpack_public_path__ + "static/media/campaign-optimization.cc2b75875eeabc16d8e4e11c1d26b498.svg";
export { ForwardRef as ReactComponent };